import { ReactNode } from 'react';
import { TimelineIcon } from '@/common/components/timeline/subcomponents/timeline-icon/TimelineIcon.tsx';
import { red } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { TimelineItem } from '@/common/components/timeline/subcomponents/timeline-item/TimelineItem.tsx';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LoopIcon from '@mui/icons-material/Loop';
import { Trans } from '@lingui/react/macro';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface TimelineErrorProps {
  isLast?: boolean;
  title: ReactNode;
  description?: ReactNode;
  onTryAgain?: () => void;
}

export const TimelineError = ({ isLast, title, description, onTryAgain }: TimelineErrorProps) => {
  return (
    <TimelineItem
      isLast={isLast}
      icon={
        <TimelineIcon color={red}>
          <ErrorOutlineIcon />
        </TimelineIcon>
      }
      rightContent={
        <Stack pt={2.2} gap={1} alignItems="start">
          <Typography variant="body1" color="error" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="textSecondary">
              {description}
            </Typography>
          )}
          {onTryAgain ? (
            <Button startIcon={<LoopIcon />} onClick={onTryAgain} variant="outlined" size="small">
              <Trans>Try again</Trans>
            </Button>
          ) : null}
        </Stack>
      }
    />
  );
};
